<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="8">
        <label for="email">Work email <span class="text-danger">*</span></label>
        <b-form-input id="email"
                      v-model="email"
                      @blur="validateEmail"
                      type="text"
                      size="md"
                      :state="emailIsValid ? null : false"></b-form-input>
        <b-form-invalid-feedback class="text-nowrap position-absolute">Please enter your company email address.</b-form-invalid-feedback>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="8" class="mt-2">
        <label for="phone-number" class="mt-3">Phone number</label>
        <b-form-input id="phone-number"
                      v-model="phoneNumber"
                      type="tel"
                      size="md"></b-form-input>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="mt-2">
        <label for="message" class="mt-3">Any details you’d like to share</label>
        <b-form-textarea id="message"
                         v-model="message"
                         rows="4"
                         :state="messageCountIsValid ? null : false"></b-form-textarea>
        <span class="mt-5 text-muted small">{{ messageCount }}/500</span>
      </b-col>
    </b-row>

    <b-row class="d-md-flex justify-content-md-between">
      <b-col class="text-muted small mt-2" cols="md-6">
        Review our <router-link to="/privacy-notice">privacy policy</router-link> to see what data we collect and how we protect them.
      </b-col>

      <b-col class="d-flex justify-content-center mt-4 mt-md-0 justify-content-md-end" cols="md-6">
        <button type="submit" @click="submit" class="d-md-inline btn btn-primary px-5 py-2-and-half font-weight-bold btn-amio">
          Request a demo
        </button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import validateEmail from '../../utils/validateEmail'
  import amioSlackService from '../../services/amio-slack.service'
  import isEmpty from 'ramda/src/isEmpty'

  export default {
    data() {
      return {
        email: '',
        emailIsValid: true,
        phoneNumber: '',
        message: ''
      }
    },

    computed: {
      emailIsEmpty() {
        return isEmpty(this.email)
      },

      messageCount() {
        return this.message.length
      },

      messageCountIsValid() {
        return this.messageCount <= 500
      }
    },

    methods: {
      validateEmail() {
        if (this.emailIsEmpty) {
          this.emailIsValid = true
          return
        }

        this.emailIsValid = validateEmail(this.email)
      },

      submit() {
        this.validateEmail()
        if (this.emailIsEmpty) {
          this.emailIsValid = false
          return
        }

        if (!this.emailIsValid || !this.messageCountIsValid) return

        amioSlackService.createNewLead(this.email, this.phoneNumber, this.message)
        this.$emit('submit')
      }
    }
  }
</script>

<style lang="scss">
.form-control.is-invalid {
  background-position-x: 98% !important;
}
</style>
